import React, { useState, useEffect } from 'react';

const PropertyPanel = ({ selectedItems, nodes, onUpdateItems }) => {
  const [properties, setProperties] = useState({});

  useEffect(() => {
    if (selectedItems.length === 1) {
      const node = nodes.find(n => n.id === selectedItems[0]);
      setProperties(node || {});
    } else {
      setProperties({});
    }
  }, [selectedItems, nodes]);

  const handleChange = (property, value) => {
    if (selectedItems.length === 1) {
      onUpdateItems(prevNodes => 
        prevNodes.map(node => 
          node.id === selectedItems[0] ? { ...node, [property]: value } : node
        )
      );
    }
  };

  if (selectedItems.length !== 1) {
    return (
      <div className="property-panel">
        <h3>Propiedades</h3>
        <p>{selectedItems.length} elementos seleccionados</p>
      </div>
    );
  }

  return (
    <div className="property-panel">
      <h3>Propiedades</h3>
      <div className="property-group">
        <label>Posición X:</label>
        <input
          type="number"
          value={properties.x || 0}
          onChange={(e) => handleChange('x', parseFloat(e.target.value))}
        />
      </div>
      <div className="property-group">
        <label>Posición Y:</label>
        <input
          type="number"
          value={properties.y || 0}
          onChange={(e) => handleChange('y', parseFloat(e.target.value))}
        />
      </div>
      <div className="property-group">
        <label>Color:</label>
        <input
          type="color"
          value={properties.color || '#3498db'}
          onChange={(e) => handleChange('color', e.target.value)}
        />
      </div>
      {properties.type === 'text' && (
        <div className="property-group">
          <label>Texto:</label>
          <input
            type="text"
            value={properties.content || ''}
            onChange={(e) => handleChange('content', e.target.value)}
          />
        </div>
      )}
    </div>
  );
};

export default PropertyPanel;